import { css } from '@emotion/react'
import {
  Spacing,
  CornerRadius,
  gemVar,
  ThemedColors,
  Typography,
  Overlay,
} from '@opallabs/gem'
import { ITEM_HEIGHT } from '../styles'

export const NO_RESULTS_ID = 'no-results-item'
export const MENU_LABEL_ID = 'cascading-menu-label'
export const composeItemId = (id: string) => `${id}-item`

export const itemsContainer = css({
  flex: '1 1 auto',
  margin: 0,
  overflow: 'auto',
  padding: 0,
})
export const itemsLabel = css({
  ...Typography.T300,
  borderBlockEnd: `1px solid ${gemVar(ThemedColors.StrokeSecondary1)}`,
  color: gemVar(ThemedColors.TextSecondary),
  margin: `${Spacing.S}px ${Spacing.S}px 0 `,
})

export const item = css({
  alignItems: 'center',
  borderRadius: CornerRadius.Small,
  display: 'flex',
  gap: Spacing.XS,
  inlineSize: '100%',
  margin: `${Spacing.XS}px 0`,
  minBlockSize: ITEM_HEIGHT,
  padding: `0 ${Spacing.S}px`,
})

export const itemHoverStyles = css({
  cursor: 'pointer',

  '[data-gem-theme="light"] &': {
    '&:hover, &:focus': {
      backgroundColor: Overlay.BL200['08'],
    },
  },
  '[data-gem-theme="dark"] &': {
    '&:hover, &:focus': {
      backgroundColor: Overlay.BD200['16'],
    },
  },
  '&[aria-disabled=true]': {
    color: gemVar(ThemedColors.TextSecondary),
    cursor: 'not-allowed',

    '&:hover, &:focus': { background: 'transparent' },
  },
})

export const itemName = css({
  alignItems: 'center',
  display: 'flex',
  flex: '1 1 auto',
  gap: Spacing.XS,
  minInlineSize: 0,
})
export const itemNameText = css({
  overflow: 'hidden',
  textOverflow: 'ellipsis',
  whiteSpace: 'nowrap',
})

export const persistentItem = css([
  item,
  {
    color: gemVar(ThemedColors.TextSecondary),
  },
])

export const itemButton = css({
  justifySelf: 'end',
})
